var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.809,
    height: 20,
    viewBox: "0 0 17.809 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "playstore",
    d: "M16.887,8.4,2.765.249a1.825,1.825,0,0,0-1.844,0L.908.258.883.273A1.824,1.824,0,0,0,0,1.846V18.153a1.825,1.825,0,0,0,.922,1.6,1.825,1.825,0,0,0,1.844,0L16.887,11.6a1.844,1.844,0,0,0,0-3.194Zm-15.7,9.889a.705.705,0,0,1-.014-.139V1.846a.683.683,0,0,1,.038-.231L9.192,9.941ZM2.9,1.68l9.149,5.282L10,9.093ZM2.645,18.465,10,10.788l2.115,2.206ZM16.3,10.581l-3.135,1.81-2.349-2.45,2.276-2.374L16.3,9.418a.671.671,0,0,1,0,1.162Zm0,0",
    transform: "translate(0.001 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.e366557a972aeaf9c57d0c756d2cfc46.svg";
export { ForwardRef as ReactComponent };